import BaseAPI from "@/apis/base/base-api";
import httpClient from "@/apis/base/axios-httpclient";
import moment from "moment";

class TransactionAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Management";
  controllerName = "logtransactions";

  /**
   * Lấy dữ liệu danh sách giao dịch
   */
  getList(payload) {
    let filter = payload.filter ? `${payload.filter}` : "";
    // if (filter.contains("TransactionTime")) {
    //     let fromDateParam = ['"', moment(payload.fromDate).format("YYYY-MM-DDTHH:mm:ss"), '"'].join("");
    //     let toDateParam = ['"', moment(payload.toDate).format("YYYY-MM-DDTHH:mm:ss"), '"'].join("");
    //     filter = filter.replace(fromDateParam, `"${payload.fromDate.toJSON()}"`);
    //     filter = filter.replace(toDateParam, `"${payload.toDate.toJSON()}"`);
    // }
    var param = {
      SkipCount: payload.skip || 0,
      MaxResultCount: payload.take || 20,
      Filter: filter,
      ListTransactionStatus: payload.ListTransactionStatus,
    };

    let request = {
      url: this.getAPIUrl() + "/merchant/list",
      data: param,
    };
    return httpClient.postAsync(request);
  }

  /**
   * Lấy bản ghi mặc định khi thêm mới
   */
  getEdit(payload) {
    let request = {
      url: this.getAPIUrl() + `/merchant/${payload.id}`,
    };
    return httpClient.getAsync(request, true);
  }

  /**
   * Lấy bản ghi mặc định khi thêm mới
   */
  getNew(payload) {
    return;
  }

  /**
   * Thêm mới
   */
  insert(payload) {
    let request = {
      url: this.getAPIUrl(),
      data: payload.Entity,
    };
    return httpClient.postAsync(request, true);
  }
  /**
   * Lấy giao dịch theo transaction id
   */
  getTransactionByID(transactionId) {
    let request = {
      url: [this.getAPIUrl(), transactionId].join("/"),
    };
    console.log([this.getAPIUrl(), transactionId].join("/"));
    return httpClient.getAsync(request, false, false);
  }

  /**
   * Lấy giao dịch theo transaction id
   */
  getRefundTransactionByID(transactionId) {
    let request = {
      url: this.getAPIUrl() + `/merchant/refund/${transactionId}`,
    };
    console.log([this.getAPIUrl(), transactionId].join("/"));
    return httpClient.getAsync(request, false, false);
  }

  /**
   * Xóa
   */
  delete(payload) {
    let request = {
      url: this.getAPIUrl() + "/" + payload.Entity[0].id,
      data: payload,
    };
    return httpClient.deleteAsync(request, true);
  }
  /**
   * Lấy giao dịch transaction theo token
   */
  getTransactionByToken(token, id) {
    let request = {
      url: [this.getAPIUrl(), "/details?", "token=", token, "&id=", id].join(""),
    };
    console.log(request.url);
    return httpClient.getAsync(request, false, false);
  }
  /**
   * Lấy dữ liệu danh sách giao dịch theo transaction id
   */
  getListTransactionByTransactionId(payload) {
    let param = {
      listTransactionId: payload.listTransactionId,
    };
    let request = {
      url: this.getAPIUrl() + "/merchant/bylistid",
      data: param,
    };
    return httpClient.postAsync(request);
  }
  /**
   * xuất excel
   * @param {} payload
   */
  async export(payload) {
    //Lấy token xuất khẩu
    let request = {
      url: window._apis[this.apiName] + "/Common/exporttoken",
    };
    let filter = payload.filter ? `${payload.filter}` : "";
    var param = {
      SkipCount: payload.skip || 0,
      MaxResultCount: payload.take || 20,
      Filter: filter,
      ListTransactionStatus: payload.ListTransactionStatus,
    };

    let url = `${this.getAPIUrl()}/exportmerchant`;
    let req = {
      url: url,
      data: param,
      responseType: "blob",
    };
    var result = await this.postAsync(req);
    const urlResult = window.URL.createObjectURL(new Blob([result]));
    const link = document.createElement("a");
    link.href = urlResult;
    link.setAttribute("download", payload.fileName); //or any other extension
    document.body.appendChild(link);
    link.click();
  }
}

export default new TransactionAPI();
